import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionV2: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.description-v-2',
		defaultMessage:
			'Give access to specific people to control who can raise this request. Restricted request types can be raised in all channels except email, chat, widget, and the virtual service agent. {linkStart}Read more about restricting request types{linkEnd}',
		description: 'Description for the request type permission configuration modal.',
	},
});
